import { TcmPage as TcmFeature } from "@/features/tcm"

export default function TcmPage() {
  return <TcmFeature />
}
